/* Solvik — la page de comparaison.
 *
 * Ce fichier ne décide de rien. Le catalogue arrive du serveur avec des
 * valeurs DÉJÀ mises en forme — le grade d'eau prudent, « sous-couche
 * intégrée » ou « à prévoir », la compatibilité chauffage — et les intitulés
 * de lignes viennent des mêmes clés de traduction que la fiche produit.
 * Il ne reste ici qu'à comparer des chaînes et à multiplier des nombres.
 *
 * L'ORDRE DE LA PAGE EST L'ORDRE DE LA DÉCISION
 *   1. les trois visuels, jointifs — c'est ce qu'on est venu voir ;
 *   2. ce qui les sépare ;
 *   3. ce que ça coûte pour SA pièce ;
 *   4. le doute qui reste, et il est traité en Liquid.
 *
 * Les visuels sont collés bord à bord, sans gouttière ni texte entre eux :
 * une couleur ne se juge pas isolément mais par comparaison, et la moindre
 * bande de fond entre deux photos fausse le jugement.
 *
 * Les valeurs passent par textContent, jamais par innerHTML. Elles viennent de
 * l'admin Shopify et non d'un visiteur, mais une donnée n'a pas à pouvoir
 * devenir du balisage — la règle ne souffre pas d'exception locale.
 */

(function () {
  'use strict';

  var LANGUE = 'fr-BE';

  /* Les lignes du tableau, en trois groupes — et le découpage n'est pas
   * cosmétique, il décide du verdict.
   *
   * Vérifié sur deux décors de la gamme Bergen : onze lignes sur treize
   * étaient identiques, et les deux « différences » étaient la COULEUR — soit
   * exactement ce qu'on regarde sur les photos — et la RÉFÉRENCE PERGO, un
   * code de commande. Compter ces deux-là comme des écarts techniques
   * empêchait le verdict « ces sols sont techniquement identiques » de sortir
   * dans le seul cas où il est vrai, et où il est utile.
   *
   * DÉCOR  : ce qui fait qu'ils ne se ressemblent pas. Affiché, jamais compté.
   * TECH   : ce qui départage à la pose et à l'usage. Seul groupe compté.
   * ID     : un identifiant. Affiché en dernier, jamais compté. */
  var LIGNES_DECOR = ['couleur'];
  var LIGNES_TECH = [
    'gamme', 'epaisseur', 'dimensions', 'format', 'classe',
    'eau', 'chauffage', 'chanfrein', 'clic', 'sous_couche', 'surface_paquet'
  ];
  var LIGNES_ID = ['reference'];
  var LIGNES = LIGNES_DECOR.concat(LIGNES_TECH, LIGNES_ID);

  function nombre(v, dec) {
    return v.toLocaleString(LANGUE, {
      minimumFractionDigits: dec === undefined ? 0 : dec,
      maximumFractionDigits: dec === undefined ? 0 : dec
    });
  }

  /* Un BUDGET s'arrondit à l'euro : personne n'attend le centime sur une
   * estimation. Un PRIX UNITAIRE, jamais — c'est le chiffre que le client
   * comparera avec la fiche produit. Même règle que le calculateur. */
  function euros(v) {
    return v.toLocaleString(LANGUE, {
      style: 'currency', currency: 'EUR',
      minimumFractionDigits: 0, maximumFractionDigits: 0
    });
  }

  function eurosExact(v) {
    return v.toLocaleString(LANGUE, {
      style: 'currency', currency: 'EUR',
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  /* Le nombre NU, sans devise.
   *
   * Le libellé d'unité du site est « €/m² » — il porte déjà le symbole, et
   * partout ailleurs le prix qui le précède sort de `money_without_currency`
   * (voir `snippets/solvik-prix.liquid`). La légende du comparateur avait
   * repris le libellé sans la convention qui va avec, et affichait donc
   * « 94,95 €€/m² » sur toutes les tailles d'écran. */
  function nombreExact(v) {
    return v.toLocaleString(LANGUE, {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  /* La vignette du sélecteur se déduit de l'image pleine : les deux URL ne
   * différaient que par le paramètre `width`, et les émettre toutes les deux
   * coûtait 20 Ko. Si le format d'URL de Shopify changeait, le remplacement
   * échoue et on retombe sur l'image pleine — plus lourde, jamais cassée. */
  function vignette(url) {
    if (!url) return '';
    return url.replace(/([?&]width=)\d+/, '$1200');
  }

  /* Le filtre `json` de Liquid echappe l'apostrophe et les chevrons en
   * entites HTML, pour qu'une chaine ne puisse pas fermer le <script> qui la
   * contient. C'est une protection reelle et il ne faut pas la contourner cote
   * serveur — mais le contenu d'un <script type="application/json"> n'est PAS
   * analyse comme du HTML : les entites y restent litterales. Affichees telles
   * quelles par textContent, elles donnaient « Tenue a l&#39;eau ».
   *
   * On decode donc ici, sur la liste fermee des entites que Liquid produit.
   * Un decodage par innerHTML ferait le travail en une ligne, mais rendrait a
   * une donnee le pouvoir de devenir du balisage — exactement ce que ce
   * fichier s'interdit. */
  var ENTITES = {
    '&#39;': "'", '&#34;': '"', '&quot;': '"',
    '&lt;': '<', '&gt;': '>', '&amp;': '&'
  };

  function decode(v) {
    if (typeof v !== 'string' || v.indexOf('&') === -1) return v;
    // `&amp;` en dernier : le remplacer d'abord recreerait les autres entites.
    return v.replace(/&(#39|#34|quot|lt|gt|amp);/g, function (m) {
      return ENTITES[m];
    });
  }

  /* Applique le décodage partout dans une structure venue du JSON. */
  function decodeTout(v) {
    if (typeof v === 'string') return decode(v);
    if (Array.isArray(v)) return v.map(decodeTout);
    if (v && typeof v === 'object') {
      var out = {};
      Object.keys(v).forEach(function (k) { out[k] = decodeTout(v[k]); });
      return out;
    }
    return v;
  }

  function el(balise, classe, texte) {
    var n = document.createElement(balise);
    if (classe) n.className = classe;
    if (texte !== undefined && texte !== null) n.textContent = texte;
    return n;
  }

  function lireJSON(racine, selecteur) {
    var n = racine.querySelector(selecteur) || document.querySelector(selecteur);
    if (!n) return null;
    try { return decodeTout(JSON.parse(n.textContent)); } catch (e) { return null; }
  }

  function demarrer() {
    var racine = document.querySelector('[data-sv-comp]');
    if (!racine || !window.SolvikComparer) return;

    var catalogue = lireJSON(racine, '[data-sv-catalogue]') || [];
    var mots = lireJSON(racine, '[data-sv-libelles]') || {};
    var API = window.SolvikComparer;

    var tauxDroit = parseFloat(racine.getAttribute('data-taux-droit')) || 10;
    var tauxBaton = parseFloat(racine.getAttribute('data-taux-baton')) || 15;

    /* Un même sol peut figurer dans deux collections : on dédoublonne par
     * handle plutôt que de faire confiance au découpage des gammes. */
    var parHandle = {};
    var sols = [];
    catalogue.forEach(function (s) {
      if (!s || !s.h || parHandle[s.h]) return;
      parHandle[s.h] = s;
      sols.push(s);
    });
    sols.sort(function (a, b) {
      return (a.f + a.g + a.d).localeCompare(b.f + b.g + b.d, LANGUE);
    });

    /* La page connaît le décor exact de chacun des 176 sols : elle en fait
     * profiter le plateau, qui n'a lui que ce qu'il a pu glaner au clic ou
     * dépanner par le réseau. Une visite ici suffit donc à remettre tous les
     * noms d'aplomb. */
    API.handles().forEach(function (h) {
      var s = parHandle[h];
      if (s) API.decrire(h, { d: s.d, img: vignette(s.img) });
    });

    var zone = racine.querySelector('[data-sv-zone]');
    var invite = racine.querySelector('[data-sv-invite]');
    var boutonAjouter = racine.querySelector('[data-sv-ouvrir]');
    var boutonVider = racine.querySelector('[data-sv-vider]');
    var panneau = document.querySelector('[data-sv-panneau]');
    var loupe = document.querySelector('[data-sv-loupe]');
    var champChercher = panneau && panneau.querySelector('[data-sv-chercher]');
    var liste = panneau && panneau.querySelector('[data-sv-liste]');
    var compte = panneau && panneau.querySelector('[data-sv-compte]');

    var surface = 0;

    function choisis() {
      // `liste()` renvoie des entrées { h, d, img } depuis que le plateau doit
      // pouvoir afficher un nom sur n'importe quelle page. Ici seul le handle
      // sert : le catalogue de la page porte des données plus complètes.
      return API.handles().map(function (h) { return parHandle[h]; })
                          .filter(function (s) { return !!s; });
    }

    /* Ce que l'écran peut porter, et ce qu'il laisse dehors.
     *
     * Sur un petit écran la limite d'ajout est de 2 (voir `solvik-comparer.js`)
     * — mais une sélection de 3 faite sur un ordinateur peut très bien arriver
     * ici. On ne la détruit pas : on en montre autant que l'écran permet de
     * lire, et on DIT lequel reste dehors. Un décor qui disparaît sans qu'on
     * le nomme est un bug pour celui qui l'avait choisi. */
    function montrables(sels) {
      var n = (typeof API.max === 'function') ? API.max() : sels.length;
      return { vus: sels.slice(0, n), restes: sels.slice(n) };
    }

    /* Les visuels ------------------------------------------------------- */

    function bandeVisuels(sels) {
      var bande = el('div', 'sv-comp__bande');
      bande.style.setProperty('--sv-colonnes', sels.length);
      sels.forEach(function (s, i) {
        var bouton = el('button', 'sv-comp__vue');
        bouton.type = 'button';
        bouton.setAttribute('aria-label', mots.agrandir || '');
        if (s.img) {
          var img = document.createElement('img');
          img.src = s.img;
          img.alt = s.d + ' — ' + s.g;
          img.loading = i < 3 ? 'eager' : 'lazy';
          bouton.appendChild(img);
        } else {
          bouton.appendChild(el('span', 'sv-comp__sansvisuel', s.d));
        }
        bouton.addEventListener('click', function () { ouvrirLoupe(sels); });  // `sels` est déjà la part montrée
        bande.appendChild(bouton);
      });
      return bande;
    }

    function legendes(sels) {
      var grille = el('div', 'sv-comp__legendes');
      grille.style.setProperty('--sv-colonnes', sels.length);
      sels.forEach(function (s) {
        var c = el('div', 'sv-comp__legende');
        c.appendChild(el('p', 'sv-comp__decor', s.d));
        c.appendChild(el('p', 'sv-comp__gamme', s.f ? s.f + ' · ' + s.g : s.g));
        if (s.p > 0) {
          var prix = el('p', 'sv-comp__prix');
          prix.appendChild(el('b', null, nombreExact(s.p)));
          prix.appendChild(el('span', 'sv-comp__unite', mots.par_m2 || ''));
          c.appendChild(prix);
        }
        var actions = el('p', 'sv-comp__legende-actions');
        var fiche = el('a', 'sv-comp__fiche', mots.voir_fiche || '');
        fiche.href = s.u;
        actions.appendChild(fiche);
        var retirer = el('button', 'sv-comp__retirer', mots.retirer || '');
        retirer.type = 'button';
        retirer.addEventListener('click', function () { API.retirer(s.h); });
        actions.appendChild(retirer);
        c.appendChild(actions);
        grille.appendChild(c);
      });
      return grille;
    }

    function ouvrirLoupe(sels) {
      if (!loupe) return;
      var boite = loupe.querySelector('[data-sv-loupe-images]');
      boite.textContent = '';
      boite.style.setProperty('--sv-colonnes', sels.length);
      sels.forEach(function (s) {
        if (!s.img) return;
        var img = document.createElement('img');
        img.src = s.img;
        img.alt = s.d + ' — ' + s.g;
        boite.appendChild(img);
      });
      if (typeof loupe.showModal === 'function') loupe.showModal();
    }

    /* Le champ surface --------------------------------------------------- */

    function blocSurface() {
      var bloc = el('div', 'sv-comp__surface');
      var lab = el('label', null, mots.surface || '');
      var champ = document.createElement('input');
      champ.type = 'number';
      champ.inputMode = 'decimal';
      champ.min = '1';
      champ.step = '0.5';
      champ.autocomplete = 'off';
      champ.className = 'sv-comp__champ';
      if (surface > 0) champ.value = String(surface);
      champ.id = 'sv-comp-surface';
      lab.setAttribute('for', champ.id);
      champ.addEventListener('input', function () {
        surface = parseFloat(champ.value) || 0;
        dessiner(true);
      });
      bloc.appendChild(lab);
      bloc.appendChild(champ);
      bloc.appendChild(el('span', 'sv-comp__unite', 'm²'));
      return bloc;
    }

    /* Le tableau --------------------------------------------------------- */

    function ligneBudget(sels) {
      // Trois règles, aucune inventée : la chute vient des réglages du thème et
      // suit le format, un paquet ne se coupe pas, le budget porte sur ce qui
      // est LIVRÉ et non sur la surface de la pièce.
      return sels.map(function (s) {
        if (!(surface > 0) || !(s.sp > 0)) return null;
        var taux = s.bat ? tauxBaton : tauxDroit;
        var aCommander = surface * (1 + taux / 100);
        var paquets = Math.ceil(aCommander / s.sp);
        var livre = paquets * s.sp;
        return { paquets: paquets, livre: livre, budget: livre * s.p };
      });
    }

    function celluleTexte(valeur) {
      var td = el('td', 'sv-comp__cellule');
      td.textContent = valeur || (mots.sans || '—');
      if (!valeur) td.classList.add('sv-comp__cellule--vide');
      return td;
    }

    function tableau(sels) {
      var boite = el('div', 'sv-comp__table-boite');
      var table = el('table', 'sv-comp__table');

      var thead = el('thead');
      var trTete = el('tr');
      trTete.appendChild(el('td', 'sv-comp__coin'));
      sels.forEach(function (s) {
        trTete.appendChild(el('th', 'sv-comp__tete', s.d));
      });
      thead.appendChild(trTete);
      table.appendChild(thead);

      var corps = el('tbody');
      var differentes = 0;
      var identiques = [];

      // Le budget d'abord : c'est la réponse à « lequel pour MA pièce ». Il
      // reste visible même si les trois coïncident — c'est ce qu'on est venu
      // chercher, pas une ligne de détail.
      var budgets = ligneBudget(sels);
      if (budgets.some(function (b) { return b; })) {
        var trPaquets = el('tr', 'sv-comp__ligne sv-comp__ligne--cle');
        trPaquets.appendChild(el('th', 'sv-comp__cle', mots.paquets || ''));
        budgets.forEach(function (b) {
          trPaquets.appendChild(celluleTexte(
            b ? nombre(b.paquets) + ' — ' + nombre(b.livre, 2) + ' m²' : ''));
        });
        corps.appendChild(trPaquets);

        var trBudget = el('tr', 'sv-comp__ligne sv-comp__ligne--cle');
        trBudget.appendChild(el('th', 'sv-comp__cle', mots.budget || ''));
        budgets.forEach(function (b) {
          trBudget.appendChild(celluleTexte(b ? euros(b.budget) : ''));
        });
        corps.appendChild(trBudget);
      }

      LIGNES.forEach(function (cle) {
        var valeurs = sels.map(function (s) { return (s.s && s.s[cle]) || ''; });
        // Une ligne vide partout n'apprend rien et allonge le tableau : les
        // accessoires ne sont pas ici, mais tous les sols ne portent pas
        // chanfrein ni référence.
        if (valeurs.every(function (v) { return !v; })) return;

        var pareilles = valeurs.every(function (v) { return v === valeurs[0]; });
        var tr = el('tr', 'sv-comp__ligne' + (pareilles ? ' sv-comp__ligne--pareille' : ''));
        tr.appendChild(el('th', 'sv-comp__cle', mots[cle] || cle));
        valeurs.forEach(function (v) { tr.appendChild(celluleTexte(v)); });

        if (pareilles) { identiques.push(tr); tr.hidden = true; }
        else if (LIGNES_TECH.indexOf(cle) !== -1) { differentes += 1; }
        corps.appendChild(tr);
      });

      table.appendChild(corps);
      boite.appendChild(table);

      var enveloppe = el('div');
      // Le constat qui a motivé la page : les écarts se jouent au niveau de la
      // gamme, pas du décor. Deux décors d'une même gamme ne diffèrent en rien
      // techniquement, et le dire est une réponse, pas un aveu d'échec.
      if (differentes === 0) {
        enveloppe.appendChild(el('p', 'sv-comp__pareil', mots.tout_pareil || ''));
      }
      enveloppe.appendChild(boite);

      if (identiques.length) {
        var bascule = el('button', 'sv-comp__bascule', mots.identiques_voir || '');
        bascule.type = 'button';
        bascule.setAttribute('aria-expanded', 'false');
        bascule.addEventListener('click', function () {
          var ouvert = bascule.getAttribute('aria-expanded') === 'true';
          identiques.forEach(function (tr) { tr.hidden = ouvert; });
          bascule.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
          bascule.textContent = ouvert ? (mots.identiques_voir || '')
                                       : (mots.identiques_cacher || '');
        });
        enveloppe.appendChild(bascule);
      }
      return enveloppe;
    }

    /* Le dessin complet -------------------------------------------------- */

    function dessiner(gardeFocus) {
      var sels = choisis();
      var actif = document.activeElement;
      var etaitSurface = gardeFocus && actif && actif.id === 'sv-comp-surface';
      var position = etaitSurface ? actif.selectionStart : null;

      zone.textContent = '';
      if (!sels.length) {
        zone.appendChild(el('p', 'sv-comp__invite', mots.vide || ''));
        if (boutonVider) boutonVider.hidden = true;
      } else {
        var part = montrables(sels);
        zone.appendChild(bandeVisuels(part.vus));
        zone.appendChild(legendes(part.vus));
        if (part.restes.length && mots.hors_ecran) {
          var noms = part.restes.map(function (s) { return s.d; }).join(', ');
          zone.appendChild(el('p', 'sv-comp__horsecran',
            mots.hors_ecran.replace('{{ decors }}', noms)));
        }
        zone.appendChild(blocSurface());
        zone.appendChild(tableau(part.vus));
        if (boutonVider) boutonVider.hidden = false;
      }
      if (boutonAjouter) {
        // Il reste actif même à trois : ajouter un quatrième sol remplace le
        // plus ancien. Le libellé le dit, plutôt que de faire un bouton mort.
        boutonAjouter.textContent = API.plein()
          ? (mots.remplacer || boutonAjouter.dataset.libelle)
          : boutonAjouter.dataset.libelle;
      }

      // Redessiner arrache le focus du champ surface à chaque frappe : on le
      // repose, curseur compris, sinon la saisie est inutilisable.
      if (etaitSurface) {
        var neuf = document.getElementById('sv-comp-surface');
        if (neuf) {
          neuf.focus();
          try { neuf.setSelectionRange(position, position); } catch (e) {}
        }
      }
    }

    /* Le sélecteur -------------------------------------------------------- */

    function remplirListe(filtre) {
      if (!liste) return;
      liste.textContent = '';
      var f = (filtre || '').trim().toLowerCase();
      var vus = 0;
      sols.forEach(function (s) {
        if (f) {
          var foin = (s.d + ' ' + s.g + ' ' + s.f).toLowerCase();
          if (foin.indexOf(f) === -1) return;
        }
        vus += 1;
        var li = el('li', 'sv-comp__option');
        var bouton = el('button', 'sv-comp__option-bouton');
        bouton.type = 'button';
        var choisi = API.contient(s.h);
        bouton.setAttribute('aria-pressed', choisi ? 'true' : 'false');
        if (choisi) bouton.classList.add('sv-comp__option-bouton--choisi');
        // Plus de bouton désactivé : au-delà de trois, le choix remplace le
        // plus ancien et le plateau l'annonce. Bloquer ici ramènerait le
        // cul-de-sac que ce dispositif supprime.

        var petite = vignette(s.img);
        if (petite) {
          var img = document.createElement('img');
          img.src = petite;
          img.alt = '';
          img.loading = 'lazy';
          bouton.appendChild(img);
        }
        var texte = el('span', 'sv-comp__option-texte');
        texte.appendChild(el('span', 'sv-comp__option-decor', s.d));
        texte.appendChild(el('span', 'sv-comp__option-gamme',
          s.f ? s.f + ' · ' + s.g : s.g));
        bouton.appendChild(texte);
        if (s.p > 0) bouton.appendChild(el('span', 'sv-comp__option-prix', eurosExact(s.p)));

        bouton.addEventListener('click', function () {
          API.basculer(s.h, { d: s.d, img: vignette(s.img) });
        });
        li.appendChild(bouton);
        liste.appendChild(li);
      });
      if (!vus) liste.appendChild(el('li', 'sv-comp__aucun', mots.aucun || ''));
      if (compte) {
        /* La phrase doit dire le nombre en vigueur ICI : annoncer « trois sols
         * au maximum » sur un écran qui n'en accepte que deux ferait passer le
         * remplacement pour un bug. */
        var etroit = typeof API.max === 'function' && API.max() < 3;
        var phrase = etroit ? (mots.plein_etroit || mots.plein) : mots.plein;
        compte.textContent = API.plein() ? (phrase || '') : '';
      }

    }

    if (boutonAjouter) {
      boutonAjouter.dataset.libelle = boutonAjouter.textContent.trim();
      boutonAjouter.addEventListener('click', function () {
        if (!panneau || typeof panneau.showModal !== 'function') return;
        remplirListe(champChercher ? champChercher.value : '');
        panneau.showModal();
        if (champChercher) champChercher.focus();
      });
    }
    if (champChercher) {
      champChercher.addEventListener('input', function () {
        remplirListe(champChercher.value);
      });
    }
    if (boutonVider) {
      boutonVider.addEventListener('click', function () { API.vider(); });
    }

    document.addEventListener('solvik:comparer', function () {
      dessiner(false);
      if (panneau && panneau.open) remplirListe(champChercher ? champChercher.value : '');
    });

    if (invite) invite.remove();
    dessiner(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
